var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewPasswordForm',{attrs:{"error4017":_vm.error4017},on:{"submit":_vm.submit,"cancel":_vm.cancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }